import styled from '@emotion/styled';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import { useIsCurrentPath } from '../../hooks';

interface ListExternalLinkButtonProps {
  to: string;
  icon: JSX.Element;
  translationKey: string;
  showTooltip: boolean;
}

const ButtonContainer = styled.a`
  color: ${props => props.theme.palette.text.primary};
  text-decoration: none;
`;

const ListExternalLinkButton = ({
  to,
  icon,
  translationKey,
  showTooltip,
}: ListExternalLinkButtonProps) => {
  const isCurrentPath = useIsCurrentPath(to);
  const { t } = useTranslation();
  const isCollapsed = showTooltip;
  return (
    <Tooltip title={showTooltip ? t(translationKey) : ''} placement="right">
      <ButtonContainer href={to}>
        <ListItemButton
          selected={isCurrentPath}
          sx={{
            justifyContent: isCollapsed ? 'center' : 'flex-start',
            px: isCollapsed ? 1 : undefined,
            minHeight: 46,
          }}
        >
          <ListItemIcon
            sx={
              isCollapsed
                ? {
                    minWidth: 0,
                    mr: 0,
                    justifyContent: 'center',
                  }
                : undefined
            }
          >
            {icon}
          </ListItemIcon>
          {!isCollapsed && <ListItemText primary={t(translationKey)} />}
        </ListItemButton>
      </ButtonContainer>
    </Tooltip>
  );
};

export default ListExternalLinkButton;
